export const searchIconStyles = { color: "#FAFAFA" };

export const toddleIconTooltipOverlayStyle = {
  width: "28px",
  pointerEvents: "none",
};
